import store from './store'

store.dispatch('updateNetwork')
document.addEventListener(
  'offline',
  () => store.dispatch('setNetwork', false),
  false
)
// try connection check again even it is online callback
document.addEventListener(
  'online',
  () => store.dispatch('updateNetwork'),
  false
)
